import { createStore, combineReducers, applyMiddleware } from 'redux';

import { metaReducer } from '../modules/Meta/reducer';
import { feedsReducer } from '../modules/Feeds/reducer';

const reducers = combineReducers({
    metaState: metaReducer,
    feedsState: feedsReducer,
});

const store = createStore(
    reducers,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
);

export default store;
